import Plugin from "@ckeditor/ckeditor5-core/src/plugin"
import UnderlineColorCommand from "./underlinecolorcommand"
import { UNDERLINE_COLOR } from "./utils"

export default class UnderlineColorEditing extends Plugin {
  constructor(editor) {
    super(editor)

    editor.config.define(UNDERLINE_COLOR, {
      colors: [
        {
          color: "hsl(0, 0%, 0%)",
          label: "Black",
        },
        {
          color: "hsl(0, 0%, 30%)",
          label: "Dim grey",
        },
        {
          color: "hsl(0, 0%, 60%)",
          label: "Grey",
        },
        {
          color: "hsl(0, 0%, 90%)",
          label: "Light grey",
        },
        {
          color: "hsl(0, 0%, 100%)",
          label: "White",
          hasBorder: true,
        },
        {
          color: "hsl(0, 75%, 60%)",
          label: "Red",
        },
        {
          color: "hsl(30, 75%, 60%)",
          label: "Orange",
        },
        {
          color: "hsl(60, 75%, 60%)",
          label: "Yellow",
        },
        {
          color: "hsl(90, 75%, 60%)",
          label: "Light green",
        },
        {
          color: "hsl(120, 75%, 60%)",
          label: "Green",
        },
        {
          color: "hsl(150, 75%, 60%)",
          label: "Aquamarine",
        },
        {
          color: "hsl(180, 75%, 60%)",
          label: "Turquoise",
        },
        {
          color: "hsl(210, 75%, 60%)",
          label: "Light blue",
        },
        {
          color: "hsl(240, 75%, 60%)",
          label: "Blue",
        },
        {
          color: "hsl(270, 75%, 60%)",
          label: "Purple",
        },
      ],
      columns: 5,
    })

    editor.conversion.for("upcast").elementToAttribute({
      view: {
        name: "span",
        styles: {
          background: /linear-gradient([\s\S]+)/,
        },
      },
      model: {
        key: UNDERLINE_COLOR,
        value: (viewElement) => {
          const styleValue = viewElement.getStyle("background")
          const result = styleValue.match(
            /linear-gradient\(transparent \d+%, ([\s\S]+\)) \d/
          )
          if (result) {
            return result[1]
          } else {
            return styleValue
          }
        },
      },
    })

    editor.conversion.for("downcast").attributeToElement({
      model: UNDERLINE_COLOR,
      view: (modelAttributeValue, viewWriter) =>
        viewWriter.createAttributeElement(
          "span",
          {
            style: `background:linear-gradient(transparent 80%, ${modelAttributeValue} 0)`,
          },
          { priority: 7 }
        ),
    })

    editor.commands.add(UNDERLINE_COLOR, new UnderlineColorCommand(editor))

    // Allow the underlineColor attribute on text nodes.
    editor.model.schema.extend("$text", { allowAttributes: UNDERLINE_COLOR })

    editor.model.schema.setAttributeProperties(UNDERLINE_COLOR, {
      isFormatting: true,
      copyOnEnter: true,
    })
  }

  modifyUnderLineStyle(value) {
    return `linear-gradient(transparent 80%, ${value} 0)`
  }
}
